import React, { useState, useContext, useEffect, useRef } from "react";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import editIcon from "./../../images/editIconBlue.svg";
import checkIcon from '../../images/checkmark.svg';
import Service from "../../services";
import { AxiosError, AxiosResponse } from "axios";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { BankUserContext } from "../../bankUserContext";
import { APP_Config } from "../../utils/AppConfig";
import FinSpinner from "../../commonfields/FinSpinner";
import { catchError } from "../../utils/Utils";
import CreateLeadMaster from "../layout/Leads/CreateLeadMaster";
import Select from "react-select";
import { toast } from "react-toastify";
import { TrackersEnum } from "../../models/TrackerModel";
import { RoutesEnum } from "../../utils/RoutesUtil";
import {
  ActionBtnTypes,
  ExpiryDateModel,
  IActionBtnsModel,
  ISignStatusModel,
  StatusWidgetsInfo,
  ToastType,
  WIDGET_TYPE,
  popupbtnType,
} from "../../models/StatusTabModel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { TriggerContext } from "../../Context/TriggerContext";
import { catchErrorGeneric } from "../../utils/GeneralUtils";
import EditEmailInfoForm from "./EditEmailInfoForm";
import errorEmail from "../../images/errorEmil.svg";
import emailerrorInfo from "../../images/emil-errorInfo.svg";
import ComplianceReviewPercentage from "./ComplianceReviewPercentage";
import ApplicationProgress from "./ApplicationProgress";

import ReactFileViewer from "../../commonfields/ReactFileViewer";
interface IStatusTabProps {
  leadData: any;
  getLeadData: () => void;
  setIframeActivate: React.Dispatch<React.SetStateAction<boolean>>;
  setIframeUrl: React.Dispatch<React.SetStateAction<string>>;
  loadStausTab: Boolean;

}

function StatusTab(props: IStatusTabProps) {
  const service = new Service();
  const context = useContext(BankUserContext);
  const triggerContext = useContext(TriggerContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { clientId, clientProductsId, trackerName } = useParams();
  const Trigger = useContext(TriggerContext);
  const { setIframeActivate, setIframeUrl } = props;

  // const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownValue, setDropDownValue] = useState("");

  // const [createNda, setCreateNda] = useState({});
  const [editLead, setEditLead] = useState<boolean>(false);
  const [loader, setLoader] = useState<boolean>(false);
  const [fileLoader, setFileLoader] = useState<boolean>(false);
  const [buttonName, setButtonName] = useState<string>("");
  const [productData, setProductData] = useState([]);
  const [init, setInit] = useState(true);
  const [actionBtns, setActionBtns] = useState<IActionBtnsModel[]>([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [productInfo, setProductInfo] = useState([]);
  const [locationInfo, setLocationInfo] = useState([])
  const [genericModal, setGenericModal] = useState(false);
  const [fileData, setFileData] = useState<any>(null);
  const [voidModal, setVoidModal] = useState<boolean>(false);
  const [confirmVoidModal, setConfirmVoidModal] = useState<boolean>(false);
  const [resendModal, setResendModal] = useState<boolean>(false);
  const [decisionMakingModal, setDecisionMaking] = useState<boolean>(false);
  const [expiryDate, setExpiryDate] = useState<ExpiryDateModel[]>([])
  const [emailModal, setEmailModal] = useState<boolean>(false);
  const [editEmail, setEditEmail] = useState<any>({})
  const [statusWidgetsInfo, setStatusWidgetsInfo] = useState<StatusWidgetsInfo[]>()
  const [currenetActionSignBtn, setCurrenetActionSignBtn] = useState<any>({});
  const [editEmailError, setEditEmailError] = useState<any>({});
  const [emailLoader, SetemailLoader] = useState<boolean>(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState<boolean>(false);
  const [confirmVoidInProgess, setConfirmVoidInProgess] = useState<boolean>(false);
  const [signerListCheck, setSignerListCheck] = useState<boolean>(false);
  const [signerList, setSignerList] = useState<ISignStatusModel[]>([
    // {
    //   signerName: "John Jacobs",
    //   signingStatus: "",
    //   signerEmail: "john@popsdonuts.com",
    //   signerDocusignUrl: null,
    // },
    // {
    //   signerName: "Kevin Jones",
    //   signingStatus: "completed",
    //   signerEmail: "kevin@popsdonuts.com ",
    //   signerDocusignUrl: null,
    // },
    // {
    //   signerName: "Erica Walley",
    //   signingStatus: "failed",
    //   signerEmail: "erica@popsdonuts.com ",
    //   signerDocusignUrl: null,
    // },
  ]);
  const categories = [
    {
      name: "Merchant Information",
      parentCategoeryCompletedPercentage: 0,
    },
    {
      name: "Business Equipment",
      parentCategoeryCompletedPercentage: 0,
    },
    {
      name: "Business Documents",
      parentCategoeryCompletedPercentage: 0,
    },
  ];

  const toggleGenericModal = () => setGenericModal((prev) => !prev);

  const getProducts = (search?: string) => {
    setLoader(true);
    let data: {
      screen: string;
      sections: string;
      clientId: any;
      isJsonReturnObject: boolean;
      search?: string;
    } = {
      screen: "ProspectDetails",
      sections: "GetClientProducts",
      clientId: clientId,
      isJsonReturnObject: false,
    };

    if (search) {
      data.search = search;
    }
    service
      .getProductsData(data)
      .then((response: AxiosResponse<any>) => {
        setProductData(
          response.data?.map((p: any) => {
            p.value = p.productid;
            p.label = p.productname + " - " + p.account;
            setProductInfo(response.data);
            return p;
          })
        );
        const selectedValue = response.data?.find(
          (m: any) => m?.clientid === clientId
        )?.productid;
        setDropDownValue(selectedValue);
        props?.getLeadData();
        setLoader(false);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });
  };
  const getLocations = (search?: string) => {
    setLoader(true);
    let data: {
      screen: string;
      sections: string;
      clientId: any;
      isJsonReturnObject: boolean;
      search?: string;
    } = {
      screen: "CustomerDetails",
      sections: "GetRelationshipProductsByclientId",
      clientId: clientId,
      isJsonReturnObject: false,
    };

    if (search) {
      data.search = search;
    }
    service
      .getProductsData(data)
      .then((response: AxiosResponse<any>) => {
        setLocationInfo(
          response.data?.map((p: any) => {
            p.value = p.productid;
            p.label = p.productname + " - " + p.account;
            return p;
          })
        );

        setLoader(false);

      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });

  };
  // const statusChange = (status: string) => {
  //   setLoader(true);
  //   const data = {
  //     sections: "changeClientStatus",
  //     workflowRelated: true,
  //     orgId: context?.bankuserDetails?.organization.orgId,
  //     clientId: clientId,
  //     clientProductId: clientProductsId,
  //     moveToStatus: status,
  //   };
  //   service
  //     .moveToContact(data)
  //     .then((response: AxiosResponse<any>) => {
  //       // props.refreshTrackers && props.refreshTrackers();
  //       // setCreateNda({});
  //       // toast.success("Successfully Created NDA!");4
  //       navigate(0);
  //       setLoader(false);
  //     })
  //     .catch((error: AxiosError) => {
  //       catchError(error, true);
  //       setLoader(false);
  //     });
  // };

  const handleEdit = () => {
    setButtonName("Save");
    setEditLead(!editLead);
  };

  const onChangeProductData = (e: any) => {
    if (e.clientproductid !== clientProductsId) {
      triggerContext?.setValue(true);
      navigate(
        `/${RoutesEnum.TRACKER_DETAILSPAGE}/${trackerName}/${e.clientid}/${e.clientproductid}`
      );
    }
  };
  useEffect(() => {
    getProducts();
    getLocations()
    props.getLeadData();
  }, [props?.loadStausTab]);

  useEffect(() => {
    getProducts();
    getLocations()
    props.getLeadData();
  }, [clientProductsId]);

  const getBtnsByClientDetails = () => {
    if (context?.bankuserDetails?.organization?.orgId && clientProductsId) {
      const payload = {
        screen: "Client Details",
        sections: "getBtnsByClientDetails",
        orgId: context?.bankuserDetails?.organization?.orgId,
        clientProductId: clientProductsId,
        isJsonReturnObject: true,
        roleId: context?.bankRolesData?.roleId
      };
      service
        .getBtnsByClientDetails(payload)
        .then((res) => {
          setActionBtns(res?.data?.sort((a, b) => a?.btnOrder - b?.btnOrder))
        }
        )
        .catch((err) => catchError(err, true));
    }
  };

  const getParameterValues = (btn: IActionBtnsModel) => {
    const selectedProduct = props?.leadData[0]?.clientProducts?.find((each: any) => each.clientProductsId === clientProductsId)
    const info: any = {
      ...btn,
      clientId,
      clientProductsId,
      productId: selectedProduct?.product_id,
      productCode: selectedProduct?.productCode,
      orgId: context?.bankuserDetails?.organization?.orgId,
      signerEmail: context?.bankuserDetails?.email,
      signerModifiedEmail: context?.bankuserDetails?.organization?.email,
      returnUrl: `${APP_Config().REACT_APP_REDIRECT_LINK_IN_APP}${RoutesEnum.DOCU_SIGN_REDIRECT}`,
    };
    const payload = {};
    btn?.parameters?.forEach((each) => {
      if (each?.parameterName) {
        Object.assign(payload, {
          [each?.parameterName]: info?.[each?.parameterName],
        });
      }
    });
    return payload;
  };

  const getDocuSignDocument = (id: string) => {
    setFileLoader(true);

    service
      .getDocuments(id)
      .then((res) => {
        setFileData({
          data: res.data,
          fileType: res.data.fileType,
          uri: `data:application/${res?.data?.fileType || "pdf"};base64,${res?.data?.fileContent
            }`,
        });
        toggleGenericModal();
        setFileLoader(false);
      })
      .catch((err) => {
        catchError(err, true);
        setFileLoader(true);
      });
  };

  const getSignerStatus = () => {
    setSignerListCheck(true)
    setLoader(true);
    let selectedProductSession = null;
    const selectedProductSessionRaw = sessionStorage.getItem("selectedProduct");
    if (selectedProductSessionRaw) {
      selectedProductSession = JSON.parse(selectedProductSessionRaw);
    }
    // if (
    //   context?.bankuserDetails?.organization?.orgId &&
    //   context?.bankuserDetails?.email &&
    //   selectedProductSession
    // ) 
    // {
    const payload = {
      screen: "DocuSign Signer Status",
      sections: "DocuSign",
      clientId,
      clientProductsId,
      documentType: statusWidgetsInfo?.[0]?.documentType,
      orgId: context?.bankuserDetails?.organization?.orgId,
      productId: selectedProductSession?.orgLevelProductId,
      returnUrl: `${APP_Config().REACT_APP_REDIRECT_LINK_IN_APP}${RoutesEnum.DOCU_SIGN_REDIRECT
        }`,
      userEmail: context?.bankuserDetails?.email,
    };

    service
      .getSignerStatus(payload)
      .then((res) => setSignerList(res.data))
      .catch((err) => catchError(err, true))
      .finally(() => {
        setLoader(false)
        setSignerListCheck(false)
      });
    // } else toast.error(" getSignerStatus");
  };

  const triggerBtnsResponse = async (btn: IActionBtnsModel) => {
    //resend & remove
    // redirect
    if (btn?.btnType === ActionBtnTypes.REDIRECT) {
      if (btn?.value) {
        const parseValue = parseInt(btn?.value);
        if (Number.isNaN(parseValue)) {
          sessionStorage.setItem("selectedButton", JSON.stringify(btn));
          navigate(btn?.value, { state: btn?.stateVariables });
        } else navigate(parseValue);

      } else {
        catchErrorGeneric("Something went wrong");
        // toast.error("Something went wrong.");
      }
    }
    // redirect to new tab

    if (btn?.btnType === ActionBtnTypes.REDIRECT_TAB) {

      if (btn?.value) {
        const parseValue = parseInt(btn?.value);
        if (Number.isNaN(parseValue)) {
          sessionStorage.setItem("selectedButton", JSON.stringify(btn));
          // navigate(btn?.value);
          window.open(btn?.value)
        } else navigate(parseValue);
      } else {
        catchErrorGeneric("Something went wrong");
        // toast.error("Something went wrong.");
      }
    }


    // toast
    else if (btn?.btnType === ActionBtnTypes.TOAST) {
      if (btn?.value && btn?.toastType) {
        if (btn?.toastType === ToastType.SUCCESS) {
          toast.success(btn.value);
        }
        if (btn?.toastType === ToastType.ERROR) {
          toast.error(btn.value);
        }
      } else catchErrorGeneric("Something went wrong");
      // toast.error("Something went wrong.");
    }

    // change status
    else if (btn?.btnType === ActionBtnTypes.CHANGE_STATUS) {
      // make it dyanmic later
      // if(btn.label === 'Void'){
      //       setVoidModal(false);
      // }
      if (btn?.moveToStatus && btn?.sections) {
        onActionBtnClick(btn);
      } else catchErrorGeneric("Something went wrong");
      // toast.error("Something went wrong.");
    }

    // api check
    else if (btn?.btnType === ActionBtnTypes.API_CHECK) {
      // make it dyanmic later
      // if(btn.label === 'Resend'){
      //   setResendModal(false);
      // }
      if (btn?.sections) {
        onActionBtnClick(btn);
      } else catchErrorGeneric("Something went wrong");
      // toast.error("Something went wrong.");
    }

    // view document
    else if (btn?.btnType === ActionBtnTypes.VIEW_DOCUMENT) {
      if (btn?.value) {
        getDocuSignDocument(btn?.value);
      } else catchErrorGeneric("Something went wrong");
      // toast.error("Something went wrong.");
    } else if (btn?.btnType === ActionBtnTypes.IFRAME) {
      if (btn?.value) {
        setIframeActivate(true);
        setIframeUrl(btn?.value);
      } else catchErrorGeneric("Something went wrong");
      // toast.error("Something went wrong.");
    }

    // modal
    else if (btn?.btnType === ActionBtnTypes.MODAL) {
      // Todo: need to integrate after backend is confirmed
    }
    else if (btn?.btnType === ActionBtnTypes.RESEND) {
      if (btn?.value) {
        resendEnvelope();
      } else catchErrorGeneric("Something went wrong");
      // toast.error("Something went wrong.");
    }
    else if (btn?.btnType === ActionBtnTypes.POPUPBTN) {
      if (btn?.popupName) {
        setDecisionMaking(true)
      } else {
        catchErrorGeneric("Something went wrong");
        toast.error("Something went wrong.");

      }

      // toast.error("Something went wrong.");
    }
    else if (btn?.popupbtnType === popupbtnType.APPROVE) {
      if (btn?.moveToStatus && btn?.sections) {
        onActionBtnClick(btn);
      } else catchErrorGeneric("Something went wrong");
    }
    else if (btn?.popupbtnType === popupbtnType.DENY) {
      if (btn?.moveToStatus && btn?.sections) {
        onActionBtnClick(btn);
      } else catchErrorGeneric("Something went wrong");
    }

  };

  const getStatusWidgetsInfo = () => {
    const payload = {
      screen: "clientDetails",
      sections: "getStatusWidgetsInfo",
      clientId: clientId,
      clientProductsId: clientProductsId,
      "isJsonReturnObject": true
    }
    service.getLeadsData(payload)
      .then((response: AxiosResponse<any>) => {
        setStatusWidgetsInfo(response.data)
      })
      .catch((err) => {
        catchError(err, true)
      });
  }

  const onActionBtnClick = (btn: IActionBtnsModel) => {
    setLoader(true);
    const payload = getParameterValues(btn);
    service
      .btnsUpdateData(payload)
      .then((res) => {
        if (res?.data) {
          const sortedValues = res?.data?.sort(
            (a, b) => a?.btnOrder - b?.btnOrder
          );
          sortedValues?.forEach(
            async (each) => await triggerBtnsResponse(each)
          );

        }
      })
      .catch((err) => catchError(err, true))
      .finally(() => { setLoader(false); setConfirmVoidInProgess(false) })
  };

  const onActionBtnClickCheck = (btn: IActionBtnsModel) => {
    setIsBtnDisabled(true);
    setLoader(true);
    const payload = getParameterValues(btn);
    service
      .btnsUpdateData(payload)
      .then((res) => {
        if (res?.data) {
          const sortedValues = res?.data?.sort(
            (a, b) => a?.btnOrder - b?.btnOrder
          );
          sortedValues?.forEach(
            async (each) => await triggerBtnsResponse(each)
          );

        }
      })
      .catch((err) => catchError(err, true))
      .finally(() => setLoader(false));
  };

  useEffect(() => {
    getProducts();
    props?.getLeadData();

    getSignerStatus();
  }, []);

  useEffect(() => {
    (clientProductsId || selectedProduct) && getStatusWidgetsInfo()
  }, []);

  useEffect(() => {
    if (context?.bankuserDetails?.organization?.orgId && init) {
      getBtnsByClientDetails();
      setInit(false);
    }
  }, [context?.bankuserDetails?.organization?.orgId]);

  useEffect(() => {
    if (clientProductsId && productData?.length) {
      const id = productData?.find(
        (p: any) => p.clientproductid === clientProductsId
      );

      setSelectedProduct(id || "");
      id && triggerContext?.setProductDetails(id)
      triggerContext?.setValue(true);
    }
  }, [clientProductsId, productData]);

  const TooltipWrapper = (content: string = "") => {
    return (
      <div className="lable tooltip-container">
        <span className="title">
          {content.length > 20 ? content.substring(0, 20) + "..." : content}
        </span>

        {content.length > 20 && <span className="tooltiptext">{content}</span>}
      </div>
    );
  };


  const onActionSignBtnClick = (btn: any) => {
    setCurrenetActionSignBtn(btn);
    if (btn.label === 'Resend') {
      setResendModal(true);
    } else if (btn.label === 'Void') {
      setVoidModal(true);
    }
  }

  const handleVoid = () => {
    setVoidModal(pre => !(pre))
  }
  const handleResand = () => {
    setResendModal(pre => !(pre))
  }

  const handleDecisionMaking = () => {
    setDecisionMaking(pre => !(pre))
  }
  const selectConfirmVoid = () => {
    setConfirmVoidModal(pre => !(pre))

  }

  const resendEnvelope = () => {
    setLoader(true);
    setResendModal(false)
    let selectedProductSession = null;
    const selectedProductSessionRaw = sessionStorage.getItem("selectedProduct");
    if (selectedProductSessionRaw) {
      selectedProductSession = JSON.parse(selectedProductSessionRaw);
    }
    const data = {
      sections: "changeClientStatus",
      workflowRelated: true,
      orgId: context?.bankuserDetails?.organization.orgId,
      clientId: clientId,
      clientProductId: clientProductsId,
      productId: selectedProductSession?.orgLevelProductId,
      documentType: statusWidgetsInfo?.[0]?.documentType,
      signerEmail: context?.bankuserDetails?.email,
      signerModifiedEmail: context?.bankuserDetails?.organization?.email

    };
    service
      .resendEnvelope(data)
      .then((response: AxiosResponse<any>) => {
        toast.success(response.data)
        setResendModal(false)
        setLoader(false);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });

  };
  const EditemailFormSubmit = (e: any, formValues: any) => {
    e.preventDefault();
    setLoader(true);
    let selectedProductSession = null;
    const selectedProductSessionRaw = sessionStorage.getItem("selectedProduct");
    if (selectedProductSessionRaw) {
      selectedProductSession = JSON.parse(selectedProductSessionRaw);
    }
    const data = {
      sections: "changeClientStatus",
      workflowRelated: true,
      orgId: context?.bankuserDetails?.organization.orgId,
      clientId: clientId,
      clientProductId: clientProductsId,
      productId: selectedProductSession?.orgLevelProductId,
      documentType: statusWidgetsInfo?.[0]?.documentType,
      signerEmail: editEmail?.email,
      signerModifiedEmail: formValues.newEmail || null

    };
    setEditEmailError({});
    SetemailLoader(true)
    service
      .editEmail(data)
      .then((response: AxiosResponse<any>) => {
        setLoader(false);
        getSignerStatus()     // to refresh the email in signature widget
        setEmailModal((prev) => !prev);    // to close the editEmail pop up
      })
      .catch((error: AxiosError) => {
        if (error?.response?.status === 400) {
          setEditEmailError({ error: error?.response?.data });
        } else {
          setEditEmailError({});
          catchError(error, true);
        }
        setLoader(false);
      }).finally(() => {
        SetemailLoader(false)
      });

  };
  const envelopeExpiryDate = () => {
    setLoader(true);
    let selectedProductSession = null;
    const selectedProductSessionRaw = sessionStorage.getItem("selectedProduct");
    if (selectedProductSessionRaw) {
      selectedProductSession = JSON.parse(selectedProductSessionRaw);
    }
    const data = {
      orgId: context?.bankuserDetails?.organization.orgId,
      clientId: clientId,
      clientProductId: clientProductsId,
      productId: selectedProductSession?.orgLevelProductId,
      documentType: statusWidgetsInfo?.[0]?.documentType,
    };
    service
      .envelopeExpiryDate(data)
      .then((response: AxiosResponse<any>) => {
        setExpiryDate(response.data)
        setLoader(false);
      })
      .catch((error: AxiosError) => {
        catchError(error, true);
        setLoader(false);
      });

  };
  useEffect(() => {
    envelopeExpiryDate()
  }, [])

  const toggleEmailModal = (obj: any) => {
    setEditEmail({ name: obj.signerName, email: obj.signerEmail, status: obj.status });
    setEmailModal((prev) => !prev);
    setEditEmailError({});
  }

  return (
    <>
      {loader ? <FinSpinner /> : <></>}

      {(editLead || !editLead) && (  //editLeadInfo
        <CreateLeadMaster
          editLead={editLead}
          fromTracker={true}
          editLeadBtn={true}
          buttonName={buttonName}
          clientId={clientId}
          editLeadData={props?.leadData}
          getLeadData={props?.getLeadData}
          getProducts={getProducts}
        />
      )}

      {!location?.pathname?.includes(TrackersEnum.RELATIONSHIPS) ? (
        <div className="status-tab">
          {clientProductsId ? (
            productInfo
              .filter((p: any) => p.clientproductid === clientProductsId)
              .map((p: any) => {

                return (
                  <>
                    <div className="account-status">Account Status</div>
                    <div className="top-section">
                      <div className="location-name" >
                        {p.account == null ? (TooltipWrapper(
                          (p.productname ? p.productname : "--"))) :
                          (TooltipWrapper((p.productname ? p.productname : "--")
                            + "-" + (p.account ? p.account : "--")
                          ))}

                      </div>
                      {(p.LeadsStatusFlag === true && !triggerContext?.readOnlyMode) ? (
                        <div
                          className="edit-leadinformation"
                          onClick={() => handleEdit()}
                        >
                          <img
                            src={editIcon}
                            alt="Edit Icon"
                            className="icon"
                          />{" "}
                          Edit Lead Information
                        </div>
                      ) : (
                        " "
                      )}
                    </div>
                    <div className="bottom-section">
                      <div className="status-container">
                        <div>
                          <div className="account-status">Account Status</div>
                          <div className="status-show">
                            <div className="status">Status</div>
                            <div className="in-review">
                              {" "}
                              {props?.leadData?.[0].clientProducts?.[0].status
                                ? props?.leadData?.[0].clientProducts?.[0]
                                  .status
                                : "--"}
                            </div>
                            <div className="days-instatus">
                              {props?.leadData?.[0].clientProducts?.[0]
                                .daysinstatus ? (
                                <>
                                  {
                                    props?.leadData?.[0].clientProducts?.[0]
                                      .daysinstatus
                                  }
                                  &nbsp;&nbsp;
                                  {props?.leadData?.[0].clientProducts?.[0]
                                    .daysinstatus === 1
                                    ? "day"
                                    : "days"}
                                </>
                              ) : (
                                "0 days"
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {(statusWidgetsInfo && statusWidgetsInfo.filter((status: StatusWidgetsInfo) => status.showSignatureStatus === true).length) ||
                        (statusWidgetsInfo && statusWidgetsInfo.filter((status: StatusWidgetsInfo) => status.showApplicationProgress === true).length) ||
                        (statusWidgetsInfo && statusWidgetsInfo.filter((status: StatusWidgetsInfo) => status.showReviewProgress === true).length) ? (<>
                          <div progress-container>
                            <div className="account-progress">Account Progress</div>
                            <div className="total-container">
                              {(statusWidgetsInfo && statusWidgetsInfo.filter((status: StatusWidgetsInfo) => status.showApplicationProgress === true).length) ||
                                (statusWidgetsInfo && statusWidgetsInfo.filter((status: StatusWidgetsInfo) => status.showReviewProgress === true).length) ? (<>
                                  {(statusWidgetsInfo && statusWidgetsInfo.filter((status: StatusWidgetsInfo) => status.showApplicationProgress === true).length) ?
                                    <ApplicationProgress actionBtns={actionBtns} onActionSignBtnClick={onActionSignBtnClick} /> : ""}
                                  {(statusWidgetsInfo && statusWidgetsInfo.filter((status: StatusWidgetsInfo) => status.showReviewProgress === true).length) ?
                                    <ComplianceReviewPercentage onActionBtnClick={onActionBtnClick} actionBtns={actionBtns} onActionSignBtnClick={onActionSignBtnClick} />
                                    : ""}
                                </>) : (<></>)}

                              {statusWidgetsInfo && statusWidgetsInfo.filter((status: StatusWidgetsInfo) => status.showSignatureStatus === true).length ? (<>
                                <div className="sign-container">
                                  <div className="sign-title">Signatures Required</div>
                                  <div className="sign-btns">
                                    {actionBtns && actionBtns?.length > 0 ? (
                                      actionBtns?.filter(each => each.widgetType === WIDGET_TYPE.SIGNATURE_STATUS).map((each) => (
                                        <button
                                          key={each?.label}
                                          className={`sign-btn ${each?.label}`}
                                          onClick={() => onActionSignBtnClick(each)}
                                        >
                                          <> {each?.label}</>
                                        </button>
                                      ))
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  <div>

                                    {expiryDate && expiryDate.length > 0 && (
                                      expiryDate?.map((d: ExpiryDateModel, index: Number) => (
                                        <div className="sign-errors-container">
                                          <><img src={errorEmail} alt="errorIcon" />&nbsp;{d.envelopeExpiryFlag ? d.envelopeExpiryDate : "--"} </></div>
                                      ))
                                    )}
                                  </div>
                                  <div className="signers-list">
                                    {signerList && signerList?.length > 0 ? (
                                      signerList?.map((each) => (
                                        <div
                                          className={`signer-item ${each?.status?.toLowerCase()}`}
                                        >
                                          {each?.status?.toLowerCase() ===
                                            "autoresponded" ? (
                                            <div className="signer-error">
                                              <img src={emailerrorInfo} alt="errorIcon" />&nbsp; Failed</div>
                                          ) : (
                                            <></>
                                          )}
                                          <div className="signer-inner">
                                            <div className="signer-details">
                                              <div className="signer-name">
                                                {each?.signerName}
                                              </div>
                                              <div className="signer-email">
                                                {each?.signerEmail}
                                              </div>
                                            </div>

                                            <div className="signer-edit">
                                              <FontAwesomeIcon className="icon" onClick={() => toggleEmailModal(each)} icon={faEdit} />
                                              {each?.status?.toLowerCase() === "completed" ? <img
                                                src={checkIcon}
                                                alt="Check Icon"
                                                className="checkicon" /> : ""}


                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <div className="not-found">{signerListCheck ? "Loading......." : "No Signers Found"}</div>
                                    )}
                                  </div>
                                </div></>) : (<></>)}
                            </div>
                          </div></>) : (<></>)}


                      {(actionBtns && actionBtns?.length > 0) && (actionBtns && actionBtns.filter(each => each.widgetType === WIDGET_TYPE.ACTION_BUTTON).length > 0) ? (
                        <div className="generalButtons">
                          <div className="account-acctions">
                            Account Actions
                          </div>
                          <div className="create-nda">
                            {actionBtns && actionBtns?.length > 0 ? (
                              actionBtns?.filter(each => each.widgetType === WIDGET_TYPE.ACTION_BUTTON).map((each) => (
                                <button
                                  key={each?.label}
                                  className="account-actiontitle"
                                  onClick={() => onActionBtnClick(each)}
                                >
                                  {each?.label}
                                </button>
                              ))
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                );
              })
          ) : (
            <h5>No Product</h5>
          )}
          {!productInfo.filter(
            (p: any) => p.clientproductid === clientProductsId
          ).length && (
              <>
                <div className="account-status">Account Status</div>
                <div className="top-section">
                  <div className="location-name">No Product</div>

                  {(!triggerContext?.readOnlyMode) && <div
                    className="edit-leadinformation"
                    onClick={() => handleEdit()}
                  >
                    <img src={editIcon} alt="Edit Icon" className="icon" /> Edit
                    Lead Information
                  </div>}
                </div>
                <div className="bottom-section">
                  <div className="status-container">
                    <div>
                      <div className="account-status">Account Status</div>
                      <div className="status-show">
                        <div className="status">Status</div>
                        <div className="in-review">
                          {" "}
                          {props?.leadData?.[0].clientProducts?.[0].status
                            ? props?.leadData?.[0].clientProducts?.[0].status
                            : "--"}
                        </div>
                        <div className="days-instatus">
                          {props?.leadData?.[0].clientProducts?.[0]
                            .daysinstatus ? (
                            <>
                              {
                                props?.leadData?.[0].clientProducts?.[0]
                                  .daysinstatus
                              }
                              &nbsp;&nbsp;
                              {props?.leadData?.[0].clientProducts?.[0]
                                .daysinstatus === 1
                                ? "day"
                                : "days"}
                            </>
                          ) : (
                            "--"
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
      ) : (
        <div>
          <div className="status-tab">
            <div className="account-status">Account Status</div>
            <div className="top-section">
              <div className="drop-down">
                <Select
                  className="select-product"
                  classNamePrefix="select-product"
                  options={locationInfo}
                  onChange={onChangeProductData}
                  value={selectedProduct}
                />
              </div>
            </div>
            {clientProductsId ? (
              <div className="bottom-section">
                <div className="status-container">
                  <div>
                    <div className="account-status">Account Status</div>
                    <div className="status-show">
                      <div className="status">Status</div>
                      <div className="in-review">
                        {props?.leadData?.[0].clientProducts?.[0].status
                          ? props?.leadData?.[0].clientProducts?.[0].status
                          : "--"}
                      </div>
                      <div className="days-instatus">
                        {props?.leadData?.[0].clientProducts?.[0]
                          .daysinstatus ? (
                          <>
                            {
                              props?.leadData?.[0].clientProducts?.[0]
                                .daysinstatus
                            }
                            &nbsp;&nbsp;
                            {props?.leadData?.[0].clientProducts?.[0]
                              .daysinstatus === 1
                              ? "day"
                              : "days"}
                          </>
                        ) : (
                          "0 days"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
      {/* Decision making modal */}
      <Modal isOpen={decisionMakingModal} toggle={handleDecisionMaking} className="decision-modal" centered>
        <ModalHeader toggle={handleDecisionMaking}></ModalHeader>
        <ModalBody>
          <div className="leddetermination">Lead Determination</div>
          <div className="companyname" >{props.leadData?.[0]?.businessInfo?.[0]?.businessName}</div>
        </ModalBody>
        <ModalFooter>
          <div className="sign-btn">
            <div className="sign-btns">
              {actionBtns && actionBtns?.length > 0 ? (
                actionBtns?.filter(each => each.widgetType === WIDGET_TYPE.POPUP_BTN).map((each) => (
                  <button
                    key={each?.label}
                    className={`sign-btn ${each?.label}`}
                    // className="account-actiontitle"
                    onClick={() => onActionBtnClickCheck(each)}
                    disabled={isBtnDisabled}
                  >
                    {each?.label}
                  </button>
                ))
              ) : (
                <></>
              )}
            </div>
          </div>
        </ModalFooter>
      </Modal>

      {/* Generic modal */}
      <Modal
        className="generic-modal"
        isOpen={genericModal}
        toggle={toggleGenericModal}
        centered
      >
        <ModalHeader toggle={toggleGenericModal}>
          <div className="generic-modal-title"></div>
        </ModalHeader>
        <ModalBody>
          <div className="TC_fileView">
            {fileLoader ? (
              <FinSpinner />
            ) : (
              <ReactFileViewer fileDocument={fileData} disableHeader={true} />
            )}
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={resendModal} toggle={handleResand} className="resend-modal" centered>
        <ModalHeader toggle={handleResand}>Resend Signing</ModalHeader>
        <ModalBody>
          Resending request for signature will only be
          <div>sent to those who have not signed yet</div>
        </ModalBody>
        <ModalFooter>
          <div>
            <div ><Button className="resend" onClick={() => { onActionBtnClick(currenetActionSignBtn); setResendModal(false); }}>Resend </Button></div>
            <span className="cancel" onClick={handleResand}>Cancel</span></div>
        </ModalFooter>
      </Modal>
      <Modal isOpen={voidModal} toggle={() => setVoidModal(!voidModal)} className="void-modal" centered>
        <ModalHeader toggle={() => setVoidModal(!voidModal)}>Void Signing</ModalHeader>
        <ModalBody>
          Voiding this signing will reset the application to unsubmitted

        </ModalBody>
        <ModalFooter>
          <div className="void-btns">
            <div><Button className="ConfirmVoid" onClick={() => setConfirmVoidModal(true)}>Void</Button></div>
            <div><span className="navermind" onClick={() => setVoidModal(false)}>Nevermind</span></div>
          </div>
        </ModalFooter>
      </Modal>

      <Modal isOpen={confirmVoidModal} toggle={() => setConfirmVoidModal(!confirmVoidModal)} className="void-modal" centered>
        <ModalHeader toggle={() => { setConfirmVoidModal(false); setVoidModal(false) }} >Are you sure?</ModalHeader>
        <ModalBody>Voiding this signing will reset the application to unsubmitted.
          <div className="ConfirmVoid-text">All signers will have to re-sign.</div></ModalBody>
        <ModalFooter>
          <div className="void-btns">
            <div><Button disabled={confirmVoidInProgess} className="ConfirmVoid" onClick={() => { setConfirmVoidInProgess(true); onActionBtnClick(currenetActionSignBtn); setVoidModal(false) }} >Confirm Void</Button></div>
            <div><span className="navermind" onClick={() => { setConfirmVoidModal(false); setVoidModal(false) }}>Nevermind</span></div>
          </div>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={emailModal}
        toggle={toggleEmailModal}
        className="email-modal"

      >
        <ModalHeader toggle={toggleEmailModal} className="header-name">
          Edit Email Address
        </ModalHeader>
        <EditEmailInfoForm
          toggleHandle={toggleEmailModal}
          title={"Edit email"}
          handleFormSubmit={EditemailFormSubmit}
          data={editEmail || {}}
          signerList={signerList}
          editEmailError={editEmailError}
          loader={emailLoader}

        />
      </Modal>




    </>
  );
}

export default StatusTab;
